import {
  useSensors,
  useSensor,
  PointerSensor,
  DndContext,
  closestCenter,
  DragOverlay,
} from '@dnd-kit/core';
import { arrayMove, SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { useEffect, useState } from 'react';

export const CommonDraggableList = ({
  data,
  keyIdentifier,
  DraggableComponent,
  onChangeSequence,
}: any) => {
  const [items, setItems] = useState<any>(data);
  const [activeItem, setActiveItem] = useState<any>(null); // track the dragged item

  const sensors = useSensors(useSensor(PointerSensor));

  const handleDragStart = (event: any) => {
    const { active } = event;
    const item = items.find((i: any) => i[keyIdentifier] === active.id);
    setActiveItem(item);
  };

  const handleDragEnd = (event: any) => {
    const { active, over } = event;

    if (over && active.id !== over.id) {
      console.log(items);
      const oldIndex = items.findIndex((item: any) => {
        return item[keyIdentifier] === active.id;
      });
      const newIndex = items.findIndex((item: any) => item[keyIdentifier] === over.id);

      const updatedItems = arrayMove(items, oldIndex, newIndex);
      setItems(updatedItems);
      onChangeSequence(updatedItems);
    }
    setActiveItem(null); // reset overlay
  };

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={handleDragEnd}
      onDragStart={handleDragStart}
    >
      <SortableContext items={items} strategy={verticalListSortingStrategy}>
        {items?.map((item: any) => {
          return <DraggableComponent key={item[keyIdentifier]} data={item} />;
        })}
      </SortableContext>
      <DragOverlay>
        {activeItem ? (
          <div
            style={{
              padding: '10px 20px',
              backgroundColor: '#FAFAFA',
              border: '1px solid #ccc',
              borderRadius: '5px',
              boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
              cursor: 'grabbing',
              width: '100%',
            }}
          >
            {activeItem.sKU} - {activeItem.name}
          </div>
        ) : null}
      </DragOverlay>
    </DndContext>
  );
};
